module.exports = __webpack_public_path__ + "static/media/45_A.7ff77408.png";